import {ISerializable} from "../../../typescript-plugin/entities/ISerializable";

export enum LeasingType {
    TrafficFourgonL2H1,
    MasterFourgonL2H2,
    MasterCaisseAlu,
    TrafficMinibusL2H1,
    TrafficSpaceClassL2H1,
    MasterMinibusL2H2
}

export class SerializedLeasingType implements ISerializable{

    public type:LeasingType;

    public Deserialize(data: {}): void {
        this.type = data["leasingType"];
    }

    public Serialize(): {} {
        return {
            leasingType: this.type
        };
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/LeasingType.ts